import { SPACING } from "@/generic/config";
import { useState } from "react";
import { createListCollection, Portal, Select } from "@chakra-ui/react";
import { DropdownItem } from "@/api/base/dropdown-item";
import Text from "./Text";

const Dropdown = ({ title, placeholder, items, value, noSelectionTitle, onChange }: { title?: string, placeholder?: string, items: DropdownItem[], value: DropdownItem | null, noSelectionTitle?: string, onChange: (item: DropdownItem | null) => void }) => {
    const [selectedValue, setSelectedValue] = useState<string[]>(value ? [value.name.toString()] : []);

    // Needed directly after loading the model
    if (value?.name !== selectedValue[0]) {
        setSelectedValue(value ? [value.name.toString()] : []);
    }

    const collection = createListCollection({ items: items.map(item => ({ value: item.name, name: item.name, id: item.id })) });
    return (
        <Select.Root
            deselectable
            collection={collection}
            value={selectedValue}
            onValueChange={(e) => {
                const selectedId = e.items[0]?.id;
                // console.log("Selected:", e.items[0]);
                setSelectedValue(selectedId ? [e.items[0].name] : []);
                onChange(selectedId ? items.find(item => item.id.toString() === selectedId.toString()) || null : null);
            }}
        >
            <Select.HiddenSelect />
            <Select.Label>
                {title && (
                    <Text weight="semibold" variant="normal" mb={SPACING / 4}>
                        {title}
                    </Text>
                )}
            </Select.Label>
            <Select.Control mt={-SPACING / 2}>
                <Select.Trigger>
                    {selectedValue.length === 0 && noSelectionTitle && <Text>{noSelectionTitle}</Text>}
                    <Select.ValueText placeholder={placeholder} />
                </Select.Trigger>
                <Select.IndicatorGroup>
                    <Select.Indicator />
                </Select.IndicatorGroup>
            </Select.Control>
            <Portal>
                <Select.Positioner>
                    <Select.Content>
                        {collection.items.map((item) => (
                            <Select.Item mt={SPACING} key={item.id} item={item}>
                                {item.name}
                                <Select.ItemIndicator />
                            </Select.Item>
                        ))}
                    </Select.Content>
                </Select.Positioner>
            </Portal>
        </Select.Root >
    )
};

export default Dropdown;